import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';
import { InventoryItemWithPricing } from '../inventory-item';
import { ItemRetailPrice, ItemWholesalePrice } from '../item-price';
import { ItemPricingTableColumnID } from './column';
import { BillingTerm } from '../billing-terms/interface';

export type ItemRow = InventoryItemWithPricing & {
  wholesalePricing: ItemWholesalePrice;
  retailPricing: ItemRetailPrice;
  defaultRetailPricing: ItemRetailPrice;
  isDiscountedRetailPrice?: boolean;
  displayOriginalPrice?: boolean;
  fees: ItemFeeRow[];
  isMultiactivatable?: boolean;
  billingTerm?: BillingTerm;
  index?: number;
};

type BillingTermsConfig = {
  enabled?: boolean;
  defaultStartDate?: Date; // defaults to current date
};

export interface ItemPricingTableBaseConfig {
  partnerId: string;
  marketId: string;
  businessId?: string;
  selectionEditable?: boolean;
  quantityEditable?: boolean;
  hideColumns?: ItemPricingTableColumnID[];
  hidePriceSummary?: boolean;
  hideBorder?: boolean;
  hidePackageContents?: boolean;
  billingTermsConfig?: BillingTermsConfig;
  canEditInvoices?: boolean;
  unifiedOrdersEnabled?: boolean;
  canScheduleActivations?: boolean;
}

export interface ItemFeeRow {
  type: 'setup' | 'management';
  label: string;
  amountType: 'fixed' | 'percentage';
  retailAmount?: number;
  wholesaleAmount: number;
  retailAmountTotal?: number;
  frequency: GalaxyFrequency;
  retailDefaultAmount?: number;
}

export interface PriceSummary {
  oneTime: number;
  monthly: number;
  yearly: number;
  currency: string;
}

export interface PriceTotal {
  wholesaleTotal: PriceSummary;
  retailTotal: PriceSummary;
  initialized: boolean; // controls the loading state of the summary component
}

export interface ItemRowChangeEvent {
  item: ItemRow;
  action: ItemRowChangeEventAction;
}
export interface WholesaleSummary {
  firstPayment: number;
  futurePayments: ItemRowMapByDateAndDuration;
  currencyCode: string;
}

export interface FuturePaymentItemsMapWithCurrency {
  currencyCode: string;
  lineItemsMap: ItemRowMapByDateAndDuration;
}
export interface ItemRowMapByDateAndDuration {
  [startDate: number]: {
    [duration: number]: {
      [period in GalaxyFrequency]?: number;
    };
  };
}
//converts frequency to monthly
export const frequencyConversionValue = {
  [GalaxyFrequency.ONE_TIME]: 0,
  [GalaxyFrequency.MONTHLY]: 1,
  [GalaxyFrequency.YEARLY]: 12,
};

export const FuturePaymentScheduledTime = {
  StartChargingImmediately: 0,
  RenewIndefinitely: -1,
  NoRenewal: 0,
};

export type ItemRowChangeEventAction = 'add' | 'update' | 'delete' | 'add-billing-term' | 'edit-billing-term';

export const WHOLESALE_PRICING_CONTEXT = 'wholesale';
export const RETAIL_PRICING_CONTEXT = 'retail';
